module.exports = __webpack_public_path__ + "img/bookmark.d6baa781.svg";